@use '@design/design-tokens/typography/typography' as *;

.container {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.logoAndTitleWrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.titleWrapper {
  @include typography-v2-body-md;
  color: var(--text-default);
  overflow-wrap: break-word;
}

.subtitleWrapper {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}

.columnWrapper {
  display: flex;
  flex-direction: column;
}

.logoFallback {
  display: flex;
  height: 48px;
  width: 48px;
  border-radius: 24px;
  background-color: var(--dark-purple-12);
  color: var(--dark-purple-9);
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  @include typography-v2-title-xl;
}

.logoWrapper {
  flex-shrink: 0;
}

.styledAssetLogoContainer {
  border-radius: 50%;
}
